/* import __COLOCATED_TEMPLATE__ from './cobot.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();